import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import Sidenav from "../../components/Sidenav/Sidenav";
import { SidenavProvider } from "../../providers/SidenavProvider";

export default function Layout({ children }: PropsWithChildren) {
  return (
    <SidenavProvider>
      <Stack direction="row">
        <Sidenav />
        {children}
      </Stack>
    </SidenavProvider>
  );
}
